import React from "react";
import "./DashBoard.css";
import Subtotal from "./Subtotal";
import Feed from "./Feed";
import Post from "./Post";
import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import { Avatar, IconButton } from '@material-ui/core';
import { Link } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import FaceIcon from '@material-ui/icons/Face';
import BusinessIcon from '@material-ui/icons/Business';
import AddIcon from '@material-ui/icons/Add';
import PhoneIcon from '@material-ui/icons/Phone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Product from "./Product";
import DashBoardForm from "./DashBoardForm";
import { Button } from './globalStyles';
import StoryReel from "./StoryReel";
import Footer from "./Footer";
import Widgets from "./Widgets";
function DashBoard() {
  const [{ basket, user }, dispatch] = useStateValue();






  
  return (

    <div className="dashboard">
       <div>
         
              <div className="my__profile">
                
                <h1> Welcome to the 7 Cities Appliance Team</h1>   
                   
                <h3>  <Avatar className="avatar"  src={user?.photoURL} />  {user?.displayName}</h3>
               
              </div>
                <div className="my__profile">
                    
                     
                      <h1>Virtual Online Diagnostic and In Home Repair</h1> 

                      <h3 >In keeping each other safe we provide a virtual online diagnostic to troubleshoot the problem you are having.  In many cases most appliance owners will be able to perform repairs on their own with the technician support and save money.  If a professional is needed to complete the repair and you are within the Hampton Roads area we can get parts ordered and schedule your in-home repair.  All initial virtual fees will roll into to total cost of repair.</h3>

<div >
 
 
  <h3>If you live in the highlighted areas on the map a service technician can be dispatched to help you with your in-home service calls.</h3>
  <div >
      <iframe className="map" src="https://www.google.com/maps/d/embed?mid=1Z6PkL8wtZd0FRoiLcOf0GEDmK0hvTsWS&hl=en"   ></iframe>

  


                   <div className="my__profile">
                     <h1>Get started for only $49 </h1>
                     <a className="bookapp"  href="https://square.site/book/G0YD0RWBNZJBG/7-cities-appliance">Book Appointment Now</a>
                  
                   </div> 

                   </div>
    <h3>We would like to add new technicians to increase our in-home service area  <a className="jointeam" href="https://www.7citiesappliance.com">Join The Virtual Team</a></h3>
   
</div>
                   
<Widgets />
       <h1 className="storetitle">Please Visit Our Store we offer many Products for your home appliance needs</h1>
<a className="buttons" href="https://7-cities-appliancestore.square.site">Our Store</a> 
            
                    
                </div>

              
                 <Footer />
                
       </div>  
             
     </div> 
  );
}

export default DashBoard;
